import { combineReducers } from "redux";
import pricingGridReducer from "./pricingGridReducer";
import authReducer from "./authReducer";
import checkoutReducer from "./checkoutReducer";
import customerReducer from "./customerReducer";

const rootReducer = combineReducers({
  pricingPlans: pricingGridReducer,
  authData: authReducer,
  checkoutData: checkoutReducer,
  customersData: customerReducer,
});

export default (state, action) =>
  rootReducer(action.type === 'CLEAR_AUTH_DATA' ? undefined : state, action);